import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getSocialHistoryRows } from "./social-history-rows";

export const metadata = {
  tableType: "SocialHistoryObservations",
  displayName: "Social History",
  getRows: (bundle: FhirBundleSdk) => getSocialHistoryRows({ bundle }),
};
